import { createRouter, createWebHistory } from "vue-router";

import LoginComponent from './components/LoginComponent.vue'
import SignupComponent from './components/SignupComponent.vue'
import ForgotPasswordComponent from './components/ForgotPasswordComponent.vue'
import AboutPageComponent from './components/AboutPageComponent.vue'
import ContactComponent from './components/ContactComponent.vue'
import FAQComponent from './components/FAQComponent.vue'
import ShippingCalculatorComponent from './components/ShippingCalculatorComponent.vue'
import ShippingRestrictionsComponent from './components/ShippingRestrictionsComponent.vue'
import TermsPageComponent from './components/TermsPageComponent.vue'
import BlogsListingComponent from './components/BlogsListingComponent.vue'
import BlogDetailComponent from './components/BlogDetailComponent.vue'
import AddressComponent from './components/AddressComponent.vue'
import PaymentComponent from './components/PaymentComponent.vue'
import AccountInqueryChat from "./components/Account/AccountInqueryChat.vue";
import AccountInquiries from "./components/Account/AccountInquiries.vue";

import HomePageComponent from "./components/HomePageComponent.vue"
import CalculatorComponent2 from "./components/CalculatorComponent2.vue"

// *********** Customer Dashboard *********** //
import AccountLayout from "./components/Account/AccountLayout.vue";
import AccountDashboard from "./components/Account/AccountDashboard.vue";
import CreateShipment from "./components/Account/Shipment/CreateShipment.vue";
import AccountOrder from "./components/Account/AccountOrder.vue";
import AccountAddress from "./components/Account/AccountAddress.vue";
import AccountInvoices from "./components/Account/AccountInvoices.vue";

// Shipments
import OverallShipment from "@/components/Account/Shipment/HistoryShipment.vue";
import DraftShipment from "@/components/Account/Shipment/DraftShipment.vue";
import PendingShipment from "@/components/Account/Shipment/PendingShipment.vue";
import CartShipment from "@/components/Account/Shipment/CartShipment.vue";



const routes = [
    {
        component: LoginComponent,
        name: 'login',
        path: '/login'
    },
    {
        component: SignupComponent,
        name: 'signup',
        path: '/signup'
    },
    {
        component: ForgotPasswordComponent,
        name: 'forgot-password',
        path: '/forgot-password'
    },
    {
        component: HomePageComponent,
        name: 'home',
        path: '/'
    },
    {
        component: CalculatorComponent2,
        name: 'calculator',
        path: '/calculator'
    },
    {
        component: AboutPageComponent,
        name: 'about',
        path: '/about'
    },
    {
        component: ContactComponent,
        name: 'contact-us',
        path: '/contact-us'
    },
    {
        component: FAQComponent,
        name: 'frequently-ask-questions',
        path: '/faq'
    },
    {
        component: ShippingCalculatorComponent,
        name: 'shipping-calculator',
        path: '/shipping-calculator'
    },
    {
        component: ShippingRestrictionsComponent,
        name: 'shipping-restrictions',
        path: '/shipping-restrictions'
    },
    {
        component: TermsPageComponent,
        name: 'terms-and-conditions',
        path: '/terms-and-conditions'
    },
    {
        component: BlogsListingComponent,
        name: 'blogs-listing',
        path: '/blogs'
    },
    {
        component: BlogDetailComponent,
        name: 'blog-detail',
        path: '/blog-detail'
    },
    {
        component: AddressComponent,
        name: 'address',
        path: '/address',
        meta: { requiresAuth: true }
    },

    {
        component: PaymentComponent,
        name: 'payment',
        path: '/payment',
        meta: { requiresAuth: true }
    },
    {
        component: AccountLayout,
        name: 'account',
        path: '/account',
        meta: { requiresAuth: true },
        redirect: { name: 'account.dashboard' },
        children: [
            {
                path: 'dashboard',
                name: 'account.dashboard',
                component: AccountDashboard,
            },
            {
                path: 'shipments/create',
                name: 'account.shipments',
                component: CreateShipment,
            },
            {
                component: CreateShipment,
                name: 'account.shipments.edit',
                path: 'shipments/edit/:id?',
                meta: { requiresAuth: true },
            },
            {
                path: 'shipments/pending',
                name: 'account.shipments.pending',
                component: PendingShipment,
            },
            {
                component: OverallShipment,
                name: 'account.shipments.history',
                path: 'shipments/history',
                meta: { requiresAuth: true }
            },
            {
                component: DraftShipment,
                name: 'account.shipments.draft',
                path: 'shipments/draft',
                meta: { requiresAuth: true }
            },
            {
                component: CartShipment,
                name: 'account.shipments.cart',
                path: 'shipments/cart',
                meta: { requiresAuth: true }
            },
            {
                path: 'orders',
                name: 'account.orders',
                component: AccountOrder,
            },
            {
                path: 'inquiries',
                name: 'account.inquiries',
                component: AccountInquiries,
            },
            {
                path: 'addresses',
                name: 'account.addresses',
                component: AccountAddress,
            },
            {
                path: 'invoices',
                name: 'account.invoices',
                component: AccountInvoices,
            },
        ],
    },
    {
        component: AccountInquiries,
        name: 'inquries',
        path: '/inquiries',
        meta: { requiresAuth: true }
    },
    {
        component: AccountInqueryChat,
        name: 'AccountInqueryChat',
        path: '/Inquery/:slug',
        meta: { requiresAuth: true }
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// // Add a global beforeEach guard
// router.beforeEach((to, from, next) => {
//     // Check if the user is leaving the '/about' route
//     if (from.path === '/shipment') {
//         const answer = window.confirm('Do you really want to leave the About page? You have unsaved changes!');

//         if (answer) {
//             next(); // Allow navigation
//         } else {
//             next(false); // Prevent navigation
//         }
//     } else {
//         next(); // Continue with navigation if not leaving the '/about' route
//     }
// });

export default router